// extracted by mini-css-extract-plugin
export default {"avatarRoot":"InstrumentIcon-module_avatarRoot_jK0tLH","avatarImage":"InstrumentIcon-module_avatarImage_RaxhTI","avatarFallback":"InstrumentIcon-module_avatarFallback_KhkP3G"};